import { debug as debugGen } from "debug";
import { AbstractStore, StorePartialTrace } from "./AbstractStore";
import { LatestTrace } from "../types";

const debug = debugGen("vtTracker:ClientStore");

interface Request {
    callid: string;
    host: string;
    path: string;
    key: string;
    data?: string;
}

interface Response {
    ret: number;
    response: {
        callid: string;
        data?: string;
    };
}

const STORE_HOST = "qq.com";
const STORE_PATH = "/vip/tracker/sdk";
const CALL_TIMEOUT = 500;

export class ClientStore extends AbstractStore {
    private callMqq(method: string, req: Request): Promise<Response> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                reject(new Error("timeout"));
            }, CALL_TIMEOUT);

            if ((window as any).mqq) {
                if ((window as any).mqq.QQVersion === "0") {
                    reject(new Error("not in qq client"));
                } else {
                    (window as any).mqq.invoke(
                        "data",
                        method,
                        req,
                        (rsp: Response) => {
                            if (rsp.ret !== 0) {
                                reject(new Error(JSON.stringify(rsp)));
                            } else {
                                resolve(rsp);
                            }
                        }
                    );
                }
            } else {
                reject(new Error("no mqq"));
            }
        });
    }

    async getItem(key: string): Promise<StorePartialTrace> {
        const { response } = await this.callMqq("readH5Data", {
            callid: String(Date.now()),
            host: STORE_HOST,
            path: STORE_PATH,
            key
        });

        await this.removeItem(key);

        debug("client store trace: %o", response);

        return this.parseStore(response.data);
    }

    async setItem(key: string, data: LatestTrace): Promise<number> {
        const { ret } = await this.callMqq("writeH5Data", {
            callid: String(Date.now()),
            host: STORE_HOST,
            path: STORE_PATH,
            key,
            data: JSON.stringify(this.trace2Item(data))
        });

        return ret;
    }

    async removeItem(key: string): Promise<number> {
        const { ret } = await this.callMqq("deleteH5Data", {
            callid: String(Date.now()),
            host: STORE_HOST,
            path: STORE_PATH,
            key
        });

        return ret;
    }
}
